import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  SpellLimitation,
  SpellOverrides,
  SpellsFromList,
  UpgradableNumber,
} from "@dndModels";

import SelectSpellBox from "@dndComponents/select/SelectSpellBox";

import LoadingBox from "@components/input/LoadingBox";
import SpellLimitInput from "@dndComponents/limitations/SpellLimitInput";
import SpellOverridesInput from "@dndComponents/feature/SpellOverridesInput";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

interface Props {
  obj: SpellsFromList;
  attached_table?: AttachedTable;
  disabled: boolean;
  onChange: (changed: SpellsFromList) => void; 
}

export default function SpellsFromListInput({
  obj,
  attached_table,
  disabled,
  onChange, 
}: Props) {
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  if (reloading) {
    return (<LoadingBox />);
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 6
          }}>
          <UpgradableNumberBox
            name="How Many Spells?"
            value={obj.count} 
            disabled={disabled}
            attached_table={attached_table}
            onChange={(changed: UpgradableNumber) => {
              const new_obj = obj;
              new_obj.count = changed.clone();
              onChange(new_obj);
            }} 
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <SelectStringBox 
            name="SAA Type" 
            value={obj.saa_type} 
            options={["Standard","Extra"]}
            disabled={disabled}
            onChange={(changed: "Standard" | "Extra") => {
              const new_obj = obj;
              new_obj.saa_type = changed;
              new_obj.spell_limit = new SpellLimitation();
              onChange(new_obj);
              setReloading(true);
            }} 
          />
        </Grid>
        { obj.saa_type === "Standard" &&
          <>
            <Grid
              className="header"
              size={{
                xs: 12
              }}>Spell Limitations</Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <SpellLimitInput
                obj={obj.spell_limit}
                disabled={disabled}
                attached_table={attached_table}
                onChange={(changed: SpellLimitation) => {
                  const new_obj = obj;
                  new_obj.spell_limit = changed.clone();
                  onChange(new_obj);
                }}
              />
            </Grid>
          </>
        }
        <Grid
          className="header"
          size={{
            xs: 12
          }}>Suggested Spells</Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <SelectSpellBox 
            name="" 
            multiple
            values={ obj.suggestions } 
            disabled={ disabled }
            // log_it
            onChange={(changed: string[]) => {
              const new_obj = obj;
              new_obj.suggestions = changed;
              onChange(new_obj);
            }} 
          />
        </Grid>
        <Grid
          className="header"
          size={{
            xs: 12
          }}>Spell Alterations</Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <SpellOverridesInput
            obj={obj.spell_overrides}
            for_obj={obj}
            disabled={disabled}
            attached_table={attached_table}
            onChange={(changed: SpellOverrides) => {
              const new_obj = obj;
              new_obj.spell_overrides = changed.clone();
              onChange(new_obj);
            }}
          />
        </Grid>
      </Grid>
    );
  }
}